"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAspectRatioWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../../../themes");
exports.StyledAspectRatioWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n", "\nborder-radius: ", ";\noverflow: hidden;\nbackground-color: ", ";\n  ", ";\n"], ["\n", "\nborder-radius: ", ";\noverflow: hidden;\nbackground-color: ", ";\n  ", ";\n"])), function (_a) {
    var width = _a.width, height = _a.height;
    return "\n  width: ".concat(width, ";\n  height: ").concat(height, ";\n");
}, function (_a) {
    var containerShape = _a.containerShape;
    return containerShape === 'circle' && '50%';
}, function (_a) {
    var invert = _a.invert;
    return invert ? themes_1.colors.greyColor90 : themes_1.colors.greyColor5;
}, function (_a) {
    var disableImageBorder = _a.disableImageBorder, invert = _a.invert;
    return !disableImageBorder && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 2px solid ", "\n  "], ["\n    border: 2px solid ", "\n  "])), invert ? themes_1.colors.greyColor90 : themes_1.colors.greyColor5);
});
var templateObject_1, templateObject_2;
